import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    wrapper: "flex justify-center items-center appearance-none relative overflow-hidden aria-disabled:pointer-events-none cursor-pointer aria-disabled:cursor-default group/button active:scale-95 transition-transform duration-200",
    labelWrapper: "flex gap-2 items-center",
    label: "flex text-center items-center justify-center w-full h-full whitespace-nowrap select-none",
    iconLeft: "w-5 h-5 shrink-0 flex justify-center items-center",
    iconRight: "w-5 h-5 shrink-0 flex justify-center items-center",
    progressIcon: "flex absolute text-center items-center justify-center w-full h-full top-0 left-0"
  },
  variants: {
    justifyContent: {
      start: { labelWrapper: "justify-start" },
      center: { labelWrapper: "justify-center" },
      end: { labelWrapper: "justify-end" },
      between: { labelWrapper: "justify-between", label: "w-fit" }
    },
    alignLabel: {
      left: {
        wrapper: "justify-start"
      },
      center: {
        label: "justify-center"
      },
      right: {
        label: "justify-end"
      }
    },
    color: {
      primary: {
        wrapper: "bg-button-primary-default-bg hover:bg-button-primary-hover-bg active:bg-button-primary-active-bg aria-disabled:bg-button-primary-disabled-bg",
        progressIcon: "[&>svg]:stroke-button-primary-default-label",
        label: "text-button-primary-default-label group-aria-disabled:text-button-primary-disabled-label group-hover/button:text-button-primary-hover-label group-active:text-button-primary-active-label",
        iconLeft: "[&>svg]:fill-button-primary-default-label group-hover/button:[&>svg]:fill-button-primary-hover-label group-active:[&>svg]:fill-button-primary-active-label",
        iconRight: "[&>svg]:fill-button-primary-default-label group-hover/button:[&>svg]:fill-button-primary-hover-label group-active:[&>svg]:fill-button-primary-active-label"
      },
      secondary: {
        wrapper: "bg-button-secondary-default-bg hover:bg-button-secondary-hover-bg active:bg-button-secondary-active-bg aria-disabled:bg-button-secondary-disabled-bg",
        progressIcon: "[&>svg]:stroke-button-secondary-default-label",
        label: "text-button-secondary-default-label group-aria-disabled:text-button-secondary-disabled-label group-hover/button:text-button-secondary-hover-label group-active:text-button-secondary-active-label",
        iconLeft: "[&>svg]:fill-button-secondary-default-label group-hover/button:[&>svg]:fill-button-secondary-hover-label group-active:[&>svg]:fill-button-secondary-active-label",
        iconRight: "[&>svg]:fill-button-secondary-default-label group-hover/button:[&>svg]:fill-button-secondary-hover-label group-active:[&>svg]:fill-button-secondary-active-label"
      },
      grey: {
        wrapper: "bg-[#F6F6F6] data-[is-selected=true]:bg-black is-selected:text-white text-black",
        progressIcon: "[&>svg]:stroke-black",
        label: "group-aria-disabled:text-black/40"
      },
      white: {
        wrapper: "bg-white text-black",
        progressIcon: "[&>svg]:stroke-black",
        label: "text-black group-aria-disabled:text-black/40"
      },
      black: {
        wrapper: "bg-black text-white",
        progressIcon: "[&>svg]:stroke-white",
        label: "text-white group-aria-disabled:text-black/40"
      },
      lavender: {
        // whitepouches
        wrapper: ""
      },
      transparent: {
        wrapper: ""
      }
    },
    style: {
      solid: {
        wrapper: ""
      },
      outline: {
        wrapper: "bg-transparent border"
      },
      transparent: {
        wrapper: "bg-transparent"
      }
    },
    size: {
      xs: {
        wrapper: "h-6",
        labelWrapper: "px-2",
        progressIcon: "[&>svg]:scale-[0.8]",
        label: "text-button-sm",
        iconLeft: "w-3 h-3 shrink-0 flex justify-center items-center",
        iconRight: "w-3 h-3 shrink-0 flex justify-center items-center"
      },
      sm: {
        wrapper: "h-8",
        labelWrapper: "px-3",
        progressIcon: "[&>svg]:scale-[0.8]",
        label: "text-button-sm",
        iconLeft: "w-3 h-3 shrink-0 flex justify-center items-center",
        iconRight: "w-3 h-3 shrink-0 flex justify-center items-center"
      },
      md: {
        wrapper: "h-10",
        labelWrapper: "px-5",
        label: "text-button-md",
        iconLeft: "w-5 h-5 shrink-0 flex justify-center items-center",
        iconRight: "w-5 h-5 shrink-0 flex justify-center items-center"
      },
      lg: {
        wrapper: "h-10",
        labelWrapper: "px-5",
        label: "text-button-md",
        iconLeft: "w-5 h-5 shrink-0 flex justify-center items-center",
        iconRight: "w-5 h-5 shrink-0 flex justify-center items-center"
      }
    },
    rounded: {
      full: {
        wrapper: "rounded-full"
      },
      lg: {
        wrapper: "rounded-lg"
      },
      md: {
        wrapper: "rounded-md"
      },
      sm: {
        wrapper: "rounded-sm"
      },
      none: {
        wrapper: "rounded-none"
      }
    },
    width: {
      auto: {
        wrapper: "w-fit min-w-fit"
      },
      full: {
        wrapper: "w-full"
      },
      fixed: {
        wrapper: "w-full"
      },
      "same-as-height": {
        wrapper: "aspect-square"
      }
    },
    hover: {
      float: {
        wrapper: ""
        // whitepouches
      },
      none: {
        wrapper: ""
      }
    }
  },
  compoundVariants: [
    {
      variants: {
        color: "primary",
        style: "outline"
      },
      slots: {
        wrapper: "border-button-primary-default-bg hover:bg-button-primary-default-bg active:bg-button-primary-hover-bg aria-disabled:bg-transparent aria-disabled:border-button-primary-disabled",
        progressIcon: "[&>svg]:stroke-button-primary-default-bg group-hover:[&>svg]:stroke-button-primary-default-label",
        label: "text-button-primary-default-bg group-hover:text-button-primary-default-label"
      }
    },
    {
      variants: {
        color: "secondary",
        style: "outline"
      },
      slots: {
        wrapper: "border-button-secondary text-button-secondary hover:bg-button-secondary hover:text-button-secondary-label aria-disabled:bg-transparent aria-disabled:border-button-secondary-disabled",
        progressIcon: "[&>svg]:stroke-button-secondary group-hover:[&>svg]:stroke-button-secondary-label",
        label: "text-button-secondary group-hover:text-button-secondary-label group-aria-disabled:text-button-secondary-disabled"
      }
    },
    {
      variants: {
        size: "sm",
        width: "fixed"
      },
      slots: {
        wrapper: "max-w-[140px]"
      }
    },
    {
      variants: {
        size: "md",
        width: "fixed"
      },
      slots: {
        wrapper: "max-w-[200px]"
      }
    }
  ],
  defaultVariants: {
    style: "solid",
    color: "primary",
    size: "md",
    width: "auto",
    justifyContent: "center",
    rounded: "full"
  }
});
export {
  r as buttonBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
